import { observer } from "mobx-react-lite";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FC, useEffect } from "react";

import { appRoutes } from "@/app/router";
import { localStorageModule } from "@/modules/local-storage";
import { usePublicAppStore } from "@/store";

export const RequireStandardModeOverlayOutlet: FC = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const { publicStore } = usePublicAppStore();

  const hasSufficientAuth = publicStore.auth.isStandardMode;

  useEffect(() => {
    if (hasSufficientAuth) {
      return;
    }

    const asyncLogic = async () => {
      await localStorageModule.writePendingRedirectPath({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      });
      navigate(appRoutes.logIn({}).path, { replace: true });
    };

    asyncLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSufficientAuth, location.pathname, navigate]);

  if (!hasSufficientAuth) {
    return null;
  }

  return <Outlet />;
});
